import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined';
import Popover from 'antd/es/popover';
import React from 'react';
import { styled } from 'styled-components';

export interface ReadOnlyBadgeProps {
  title?: string;
  description?: string;
}

const BadgeContainer = styled.div`
  position: absolute;
  top: -1px;
  right: ${({ theme }) => theme.marginLG}px;
  background: ${({ theme }) => theme.colorPrimary};
  color: ${({ theme }) => theme.colorWhite};
  padding: ${({ theme }) => `${theme.paddingXXS}px ${theme.paddingSM}px`};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius}px;
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius}px;
  font-size: ${({ theme }) => theme.fontSizeSM}px;
  font-weight: ${({ theme }) => theme.fontWeightStrong};
  z-index: 10;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.marginXS}px;
`;

const InfoIcon = styled(InfoCircleOutlined)`
  font-size: ${({ theme }) => theme.fontSizeSM}px;
  opacity: 0.8;
  cursor: pointer;
  transition: opacity ${({ theme }) => theme.motionDurationMid}
    ${({ theme }) => theme.motionEaseInOut};

  &:hover {
    opacity: 1;
  }
`;

export const ReadOnlyBadge: React.FC<ReadOnlyBadgeProps> = ({
  title = 'Read-Only Mode',
  description = 'Switch to GUI mode to enable interactive editing of the pipeline',
}) => {
  return (
    <BadgeContainer>
      Read Only
      <Popover content={description} title={title} placement="bottomRight">
        <InfoIcon />
      </Popover>
    </BadgeContainer>
  );
};
